<template lang="pug">
el-collapse-item(name='uploadEvidencias')
    template(slot='title')
        h2.collapse-titulo {{ $t('mensagens.territorio.arquivo.tituloEvidencias') }}

    .collapse-conteudo
        UploadEvidenciasAr(
            @add='onAdd'
            @delete='onDelete'
            @before-delete='onBeforeDelete'
            @update='onUpdate'
            :items='items'
            :mostrar-titulo='false'
        )
</template>

<script>
import UploadEvidenciasAr from '@/components/territorio/UploadEvidenciasAr.vue';

export default {
    name: 'UploadEvidenciasCollapse',
    components: {
        UploadEvidenciasAr
    },
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        onAdd(value) {
            this.$emit('add', value);
        },
        onDelete(index) {
            this.$emit('delete', index);
        },
        onBeforeDelete(payload) {
            this.$emit('before-delete', payload);
        },
        onUpdate(payload) {
            this.$emit('update', payload);
        }
    }
};
</script>

<style lang="scss" scoped>
.collapse-titulo {
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    margin-left: 20px;
    color: #3b3b3b;
}

.collapse-conteudo {
    padding: 16px;
}
</style>
